import { ServerError } from '../types/ServerError';

export const getErrorStatus = (err: ServerError | any) => {
  const unwrappedError = err.data ?? err;
  const response = unwrappedError.response;
  const data = response?.data;
  return response?.status ?? (typeof data === 'object' ? data.statusCode : null);
};
